import { MobXProviderContext } from 'mobx-react'
import { useContext } from 'react'
import { RootStore } from '../RootStore'

export default function useStore(): RootStore {
	return useContext(MobXProviderContext).value
}
